import { useQuery } from '@apollo/client/react';
import {
  WindowedCombobox,
  WindowedComboboxProps,
} from '@optools/components/combobox/windowed-combobox';
import { GET_AUDIENCES } from '@optools/services/operator-gateway/esni/queries';
import { useMemo } from 'react';

export type AudienceSelectProps = Omit<WindowedComboboxProps, 'data'>;

export function AudienceSelect({ disabled, ...props }: AudienceSelectProps) {
  const { data, loading } = useQuery(GET_AUDIENCES);

  const audiences = useMemo(
    () => data?.audiences.map((audience) => ({ label: audience.href, value: audience.href })) ?? [],
    [data],
  );

  return (
    <WindowedCombobox
      data={audiences}
      disabled={loading || disabled}
      loading={loading}
      {...props}
    />
  );
}
